module.exports = __webpack_public_path__ + "static/anpe-811272233a87050138d4089d317b83ce.jpg";